import React from 'react';
import './utils/Transfer.css';

const Status = (props) => {
  const { color } = props;
  return (<div className='dot' style={{backgroundColor: color || 'grey', display: 'inline-block'}}>
  </div>)
};

export default Status;